import { Container, ProgressBar } from "react-bootstrap";
import "../../GamePage.scss";
import { useGameStore } from "../../stores/gameStore";
import { useTranslation } from "react-i18next";

const MemoryBar = () => {
  const memoryLevel = useGameStore((state: any) => state.memoryLevel);
  const { t } = useTranslation();

  return (
    <>
      <Container className="memory-bar-container">
        <span className="memory-bar-text">{t("game.memory")}:</span>
        <div>
          <ProgressBar now={memoryLevel} />
        </div>
      </Container>
    </>
  );
};

export default MemoryBar;
